module.exports = __webpack_public_path__ + "img/arrow-2.2871818d.svg";